import React from "react";
import TimeoutContext from "../../hooks/useResetTimeout/TimeoutContext";
import repeatEvery from "../../utils/repeatEvery";
import getCookieInt from "../../utils/getCookieInt";

const sessionExpiry = getCookieInt("session_expiry_warning_at_millis");

let timeout = Date.now() + (sessionExpiry || 0);
let callCallback = false;

let warningCallback = () => {};

let timeoutCallback = () => {};

const clockTick = () => {
  if (!callCallback && timeout && Date.now() > timeout) {
    warningCallback();
    callCallback = true;
  }
  if (timeout && Date.now() > timeout + 61000) {
    (async () => {
      await timeoutCallback();
    })();
  }
};

repeatEvery(clockTick, 1000);

const resetTimeout = () => {
  timeout = Date.now() + (sessionExpiry || 0);
  callCallback = false;
};

export { resetTimeout };

const TimeoutProvider = (props: any) => {
  if (props.onWarning) {
    warningCallback = props.onWarning;
  }

  if (props.onTimeout) {
    timeoutCallback = props.onTimeout;
  }

  return (
    <TimeoutContext.Provider value={resetTimeout}>
      {props.children}
    </TimeoutContext.Provider>
  );
};

export default TimeoutProvider;
